
import { getToken,getExpires } from '@/utils/authStore'

export function hasValidAccessToken() {
  if (getToken()) {
    const expires = getExpires()

    if (expires) {
      if (expires.set_expires_in && parseInt(expires.set_expires_in, 10) < new Date().getTime()) {
        return false
      }
      return true
    }else{
      return false
    }
  }
  return false
}